<footer class="fixed bottom-0 max-w-4xl mx-auto inset-x-0 bg-theme-lightBlue3 rounded-full p-2 mb-4 flex gap-4 items-center justify-between text-xs md:px-2 md:py-1 z-40">
  <a
    class="text-theme-mediumBlue1 w-full py-1.5 px-2 rounded-3xl cursor-pointer flex flex-col gap-1 items-center opacity-60 transition-all duration-500 ease-in-out hover:opacity-100 md:flex-row md:justify-center"
    routerLink="/home"
    routerLinkActive="bg-theme-gradient-orange !opacity-100"
    appClicks="home - resumen">
    <img
      src="https://res.cloudinary.com/superlikers/image/upload/v1768929400/menu_home_qrtf6m.svg"
      loading="lazy"
      alt="Ícono de Resumen" />
    <p>Resumen</p>
  </a>
  <a
    class="text-theme-mediumBlue1 w-full py-1.5 px-2 rounded-3xl cursor-pointer flex flex-col gap-1 items-center opacity-60 transition-all duration-500 ease-in-out hover:opacity-100 md:flex-row md:justify-center"
    routerLink="/metas"
    routerLinkActive="bg-theme-gradient-orange !opacity-100"
    appClicks="home - metas">
    <img
      src="https://res.cloudinary.com/superlikers/image/upload/v1768929400/menu_bonificacion_gwhvg3.svg"
      loading="lazy"
      alt="Ícono de metas" />
    <p>Metas</p>
  </a>
  <a
    class="text-theme-mediumBlue1 w-full py-1.5 px-2 rounded-3xl cursor-pointer flex flex-col gap-1 items-center opacity-60 transition-all duration-500 ease-in-out hover:opacity-100 md:flex-row md:justify-center"
    routerLink="autoejecucion"
    routerLinkActive="bg-theme-gradient-orange !opacity-100"
    appClicks="home - autoejecucion">
    <img
      src="https://res.cloudinary.com/superlikers/image/upload/v1768929399/menu_autoejecucion_am5xtl.svg"
      loading="lazy"
      alt="Ícono de Autoejecución" />
    <p>Autoejecución</p>
  </a>
  <a
    class="text-theme-mediumBlue1 w-full py-1.5 px-2 rounded-3xl cursor-pointer flex flex-col gap-1 items-center opacity-60 transition-all duration-500 ease-in-out hover:opacity-100 md:flex-row md:justify-center"
    routerLink="novedades"
    routerLinkActive="bg-theme-gradient-orange !opacity-100"
    appClicks="home - novedades">
    <img
      src="https://res.cloudinary.com/superlikers/image/upload/v1776874765/menu_novedades_a3rfci.svg"
      loading="lazy"
      alt="Ícono de Novedades" />
    <p>Novedades</p>
  </a>
</footer>
